import directus from '@/plugins/directusSdk'

export default {
  model: null,
  token: directus.config.token,
  firstName: '',
  lastName: ''
}
